$(".job-data__table-group-btn").on("click", function () {
	$(this).closest(".job-data__table-group").toggleClass("open")
});